import { FormFieldsController } from './form-fields.controller';
import template from './form-fields.html';

export const formFieldsComponent = {
  name: 'formFieldsComponent',
  restrict: 'E',
  template,
  controller: FormFieldsController,
  controllerAs: 'vm',
  bindings: {
    languageOptions: '<',
    translatePrefix: '@',
    hide: '<',
    centerContent: '<',
    centerLabels: '<',
    manualValidation: '<',
    autocomplete: '@',      // allow overriding autocomplete for all fields within this element (currently only applies to default-type text input)
    model: '=',
    form: '<',
    fieldGroups: '<',
    inheritModel: '<',
    expandableDepth: '<',
    index: '@?',
    fieldOptions: '<'
  }
};
